import { useSyncExternalStore } from "react";
import {
  getAudioPlaybackSnapshot,
  subscribeToAudioPlayback,
  type AudioPlaybackSnapshot,
} from "./audio";

/**
 * Subscribes React controls to the typed spoken-guidance snapshot.
 *
 * @since 1.2.0
 * @example
 * ```tsx
 * function ReplayState() {
 *   const snapshot = useAudioPlaybackSnapshot();
 *   return <output>{snapshot.status}</output>;
 * }
 * ```
 */
export function useAudioPlaybackSnapshot(): AudioPlaybackSnapshot {
  return useSyncExternalStore(
    subscribeToAudioPlayback,
    getAudioPlaybackSnapshot,
    getAudioPlaybackSnapshot,
  );
}
